import { Route, Routes, UrlMatcher, UrlSegment } from '@angular/router';
import { loginGuard } from '@core/guards/login.guard';

/** Matches (without consuming) any URL whose first segment is one of `names`. */
const firstSegmentIn =
  (...names: string[]): UrlMatcher =>
  (segments: UrlSegment[]) =>
    segments.length && names.includes(segments[0].path) ? { consumed: [] } : null;

const publicPages: Route = {
  matcher: firstSegmentIn(
    'home',
    'success',
    'faqs',
    'link',
    'terms-conditions',
    'privacy-policy',
    'about-us',
    'digital-e-card'
  ),
  loadChildren: () => import('@features/home/home.routes').then((m) => m.HOME_ROUTES),
};

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  publicPages,
  {
    path: 'contribution',
    loadChildren: () =>
      import('@features/contribution/contribution.routes').then((m) => m.CONTRIBUTION_ROUTES),
  },
  {
    path: 'auth',
    canActivate: [loginGuard],
    loadChildren: () => import('@features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'pages',
    loadChildren: () => import('@features/pages.routes').then((m) => m.PAGES_ROUTES),
  },
  { path: '**', redirectTo: 'home', pathMatch: 'full' },
];
